import React from 'react';

import '../../styles/Chat.css';

import Messages from './chat-components/Messages';
import SendMessage from './chat-components/SendMessage';
import { ScrollProvider } from '../../contexts/scrollContext';

export default function Chat() {
  return (
    <div className='chat'>
      <ScrollProvider>
        <Messages />
      </ScrollProvider>
      <SendMessage />
    </div>
  );
}
